// components/ui/FranceOnlyChip.tsx
import React from 'react';

/**
 * Marks a brand figure that covers France only (INSEE SIRENE openings, French company filings),
 * so a reader never takes a French count for the brand's worldwide network or group accounts.
 */
export const FranceOnlyChip = ({ lang }: { lang?: string }) => (
  <span
    className="shrink-0 rounded-full border border-white/10 bg-white/[0.05] px-2 py-0.5 font-medium text-white/70"
    style={{ fontSize: 10 }}
    title={lang === 'fr' ? 'Données France uniquement' : 'Data covers France only'}
  >
    {lang === 'fr' ? 'France uniquement' : 'France only'}
  </span>
);
